import React, { useState } from 'react';
import CircleCheckbox from '../../CircleCheckbox/index';
import styles from './ServiceFilter.module.css';

//import Card from '../components/Card';
import { ReactComponent as BlueCross } from 'svgs/blueCross.svg';

interface Props {
  hide: (e: any) => void;
  callback: (e: any) => void;
  locationCallback: (e: any) => void;
  params: any;
}
const ServiceFilter: React.FC<Props> = ({
  hide,
  callback,
  locationCallback,
  params,
}) => {
  const [selectedService, setSelectedService] = useState(0);
  const [selectedLocation, setSelectedLocation] = useState('');

  return (
    <div className={styles.container}>
      <BlueCross
        style={{ position: 'absolute', top: '1rem', right: '1rem' }}
        onClick={hide}
      />
      <div className={styles.title}>Filters</div>
      <div style={{ overflowY: 'scroll', overflowX: 'hidden', height: '94%' }}>
        {params?.Locations && params.Locations.length > 0 && (
          <div
            className={styles.details}
            style={{
              font: 'normal normal normal 22px/27px Roboto',
              color: '#6C6C6C',
              opacity: 1,
              marginLeft: '10px',
              marginBottom: '10px',
            }}
          >
            Locations
          </div>
        )}
        {params?.Locations &&
          params.Locations.length > 0 &&
          params.Locations.map(l => (
            <div key={l.Id} className={styles.details}>
              <CircleCheckbox
                onClick={e => {
                  setSelectedLocation(l.Id);
                  locationCallback(l);
                  hide(e);
                }}
                selected={
                  l.Id === selectedLocation ||
                  l.Id === params.SelectedLocation?.Id
                }
                className={styles.checkbox}
                selectedClassName={styles.selectedCheckbox}
              />
              <div
                onClick={e => {
                  //window.location.href = `${window.location.origin}/practice-profile/${s.Code}`;
                  setSelectedLocation(l.Id);
                  locationCallback(l);
                  hide(e);
                }}
                className={styles.name}
              >
                {l.Name}
              </div>
            </div>
          ))}
        <div
          className={styles.details}
          style={{
            font: 'normal normal normal 22px/27px Roboto',
            color: '#6C6C6C',
            opacity: 1,
            marginTop: '10px',
            marginLeft: '10px',
            marginBottom: '10px',
          }}
        >
          Services
        </div>
        {params?.Services &&
          params.Services.map(s => (
            <div key={s.Id} className={styles.details}>
              <CircleCheckbox
                onClick={e => {
                  setSelectedService(s.Id);
                  callback(s);
                  hide(e);
                }}
                selected={
                  s.Id === selectedService ||
                  s.Id === params.SelectedService?.Id
                }
                className={styles.checkbox}
                selectedClassName={styles.selectedCheckbox}
              />
              <div
                onClick={e => {
                  setSelectedService(s.Id);
                  callback(s);
                  hide(e);
                }}
                className={styles.name}
              >
                {s.Name}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ServiceFilter;
